import { ArrowUpRight, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { clearAllCache } from '@/lib/cache';
import { getDashboardLinks } from '@/lib/navigation';

export default function DashboardPage() {
  const handleClearCache = () => {
    clearAllCache();
  };

  return (
    <div className="space-y-3 sm:space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">
            Welcome back
          </h1>
          <p className="text-muted-foreground">
            Choose an admin area to get started.
          </p>
        </div>
        <Button variant="outline" onClick={handleClearCache}>
          <RefreshCw className="mr-2 h-4 w-4" />
          Clear Cache
        </Button>
      </div>
      <div className="grid grid-cols-1 gap-2 sm:gap-4">
        {getDashboardLinks().map((link) => {
          const Icon = link.icon;
          return (
            <Card key={link.to} className="transition-colors hover:bg-muted/50">
              <Link to={link.to} className="block">
                <CardHeader className="cursor-pointer">
                  <div className="flex items-center justify-between">
                    <CardTitle className="flex items-center gap-2 text-lg">
                      <Icon className="h-5 w-5" />
                      {link.title || link.label}
                    </CardTitle>
                    <ArrowUpRight className="h-4 w-4 text-muted-foreground" />
                  </div>
                  {link.description && (
                    <CardDescription>{link.description}</CardDescription>
                  )}
                </CardHeader>
              </Link>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
